export const LOGIN_PASSWORD_INPUT = 'LOGIN_PASSWORD_INPUT'
export const LOGIN_PASSWORD_CONTAINER = 'LOGIN_PASSWORD_CONTAINER'
